import type { PropsWithChildren } from 'react';
import { Box } from '@ff-it/ui';

/**
 * Type-agnostic frame for a Products and prices workspace.
 *
 * The owning activity type remains responsible for the complete composition;
 * this component supplies only the common page container.
 */
export function ProductAuthoringLayout({ children }: PropsWithChildren) {
  return <Box>{children}</Box>;
}
